import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes } from 'react-router-dom';
import { Route } from 'react-router';
import { IRouteItem } from 'routes';

import classes from './App.module.scss';

interface Props {
  client: boolean;
  routes: IRouteItem[];
  supplierWrongState: boolean;
}

const AppView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const {t} = useTranslation();

  const generateRoutes = (routes: IRouteItem[]) => {
    return routes.map((route: IRouteItem) => {
      const Component: React.FC = route['component'];

      return (
        <Route key={route.path} path={route.path} element={<Component></Component>}>
          {route.children ? generateRoutes(route.children) : null}
        </Route>
      );
    });
  };

  return (
    <Suspense fallback={null}>
      {props.supplierWrongState?<span className={classes['wrongPage']}>{t('common.supplierNotFound')}</span> :<Routes>{generateRoutes(props.routes)}</Routes>}
      
    </Suspense>
  );
};

AppView.displayName = 'AppView';
AppView.defaultProps = {};

export default AppView;
